import axios from "./axios";

export async function deleteProduct(payload) {
  return axios
    .delete(`/products/` + payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function checkProductNumber(payload) {
  return axios.get(`/products/checkNumber`, {
    params: payload,
  });
}

export async function nextProductNumber() {
  return axios.get(`/products/nextNumber`);
}

export async function createProduct(payload) {
  return axios
    .post(`/products/`, { product: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateProduct(payload) {
  return axios
    .put(`/products/` + payload.id, { product: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // return Promise.reject(error.response?.data || error)
      if (error.status !== 200) return Promise.reject(error);
      else return Promise.reject(error.response?.data || error);
    });
}

export async function listUpdateProduct(payload) {
  return axios
    .put(`/products/list`, { ids: payload.ids, product: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // return Promise.reject(error.response?.data || error)
      if (error.status !== 200) return Promise.reject(error);
      else return Promise.reject(error.response?.data || error);
    });
}

export async function fetchProduct(payload, params = {}) {
  // payload is ID, params can include fields, etc.
  return axios
    .get(`/products/` + payload, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchProducts(controller) {
  return axios({ method: "get", url: "/products", params: controller })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function bulkCreateProducts(products) {
  return axios
    .post(`/products/bulk_create`, { products: products.map(p => ({ product: p })) })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || { success: false, errors: ["Failed to create products"] });
    });
}